/**
 * 공개 사이트 공통 틀 문구 — ko/landingSite.ts 와 같은 키(정본은 ko).
 */
const landingSite = {
  "skipToContent": "រំលងទៅមាតិកា",
  "homeLabel": "ទំព័រដើម DroneSquare",
  "nav": {
    "label": "ម៉ឺនុយមេ",
    "mobileLabel": "ម៉ឺនុយទូរស័ព្ទ",
    "openMenu": "បើកម៉ឺនុយ",
    "closeMenu": "បិទម៉ឺនុយ",
    "services": "សេវាកម្ម",
    "plans": "គម្រោងប្រើប្រាស់",
    "inquiry": "សាកសួរ 1:1",
    "news": "ព័ត៌មានសារព័ត៌មាន",
    "manual": "សៀវភៅណែនាំ",
    "releases": "ព័ត៌មានថ្មីៗ"
  },
  "servicePanel": {
    "platform": {
      "title": "វេទិកា",
      "description": "ការត្រួតពិនិត្យ 2D·3D·4D ផ្នែកកាត់ និងការងារដី កំណត់ត្រាការដ្ឋាន និងការតាមដាន"
    },
    "survey": {
      "title": "ការវាស់វែងដោយ Drone និងដំណើរការទិន្នន័យលំហ",
      "description": "ចាប់ពីការអនុញ្ញាតហោះហើរ ដល់រូបភាព Ortho, DSM, ម៉ូដែល 3D និងផែនទីសណ្ឋានដីឌីជីថល"
    },
    "more": "មើលលម្អិត →"
  },
  "account": {
    "login": "ចូលប្រព័ន្ធ",
    "start": "ចាប់ផ្ដើម",
    "logout": "ចាកចេញ",
    "flightHub": "ប្រព័ន្ធបញ្ជា Drone",
    "flightHubFailed": "មិនអាចភ្ជាប់ទៅប្រព័ន្ធបញ្ជា Drone បានទេ។ សូមព្យាយាមម្ដងទៀតនៅពេលក្រោយ។"
  },
  "share": {
    "label": "ចែករំលែក",
    "menuLabel": "ចែករំលែកទំព័រនេះ",
    "copied": "បានចម្លងតំណ",
    "failed": "មិនអាចចម្លងតំណបានទេ។"
  },
  "footer": {
    "menuLabel": "ម៉ឺនុយបាតទំព័រ",
    "company": "អំពីក្រុមហ៊ុន",
    "terms": "លក្ខខណ្ឌការប្រើប្រាស់",
    "privacy": "គោលនយោបាយភាពឯកជន",
    "contact": "ការរួមប្រឹក្សា/ការទំនាក់ទំនង",
    "companyName": "ALTIVION Inc.",
    "businessNumber": "លេខចុះបញ្ជីអាជីវកម្ម: 146-81-03772",
    "address": "707 ជាន់ទី 7 KDU Tower, 640 Munjeong-dong, Songpa-gu, Seoul 05836, កូរ៉េ",
    "telLabel": "ទូរស័ព្ទចម្បង",
    "hours": "ម៉ោងធ្វើការ : 10:00 - 18:30 · សម្រាកថ្ងៃត្រង់ : 12:00 - 13:30",
    "closed": "ឈប់សម្រាកថ្ងៃសៅរ៍ អាទិត្យ និងថ្ងៃបុណ្យ",
    "copyright": "Copyright © ALTIVION Inc. All rights reserved."
  },
  "contact": {
    "telLabel": "ទូរស័ព្ទចម្បង",
    "hoursLines": ["ម៉ោងធ្វើការ : 10:00 - 18:30", "សម្រាកថ្ងៃត្រង់ : 12:00 - 13:30", "ឈប់សម្រាកថ្ងៃសៅរ៍ អាទិត្យ និងថ្ងៃបុណ្យ"],
    "inquiry": "សាកសួរ"
  },
  "sectionIndex": "ការរុករកផ្នែក",
  "sectionIndexItem": "ផ្នែកទី {{n}}",
  "flow": {
    "label": "ដំណើរការធ្វើផែនទីដោយ Drone",
    "steps": [
      {
        "title": "ការអនុញ្ញាតហោះហើរ",
        "text": "ពិនិត្យតំបន់ និងកម្ពស់ហោះហើរ ហើយទទួលការអនុញ្ញាតហោះហើរ និងថតតាមច្បាប់ពាក់ព័ន្ធ។",
        "alt": "ម្រាមដៃចង្អុលព្រំដែនដែនអាកាសលើផែនទីអាកាសចរណ៍"
      },
      {
        "title": "ផែនការថត · ការហោះស្វ័យប្រវត្តិ",
        "text": "កំណត់ផ្លូវហោះហើរ និងការត្រួតរូបថតតាមទំហំការដ្ឋាន និងគុណភាពដែលត្រូវការ ហើយថតដោយការហោះស្វ័យប្រវត្តិ។",
        "alt": "Drone ថតរូបហោះលើមេឃពណ៌ខៀវ"
      },
      {
        "title": "ការវាស់ GCP",
        "text": "ដំឡើង និងវាស់ចំណុចយោងលើដី (GCP) ដើម្បីបង្កើនភាពត្រឹមត្រូវនៃទីតាំងលទ្ធផល។",
        "alt": "ឧបករណ៍ Total Station និងព្រីសលើជើងបី"
      },
      {
        "title": "ការទទួលរូបភាព · វីដេអូ",
        "text": "ហោះតាមផ្លូវដែលបានគ្រោង ហើយថតរូបភាព និងវីដេអូការដ្ឋាន។",
        "alt": "ផ្លូវប្រសព្វផ្លូវល្បឿនលឿនដែលថតដោយ Drone"
      },
      {
        "title": "ដំណើរការ Ortho · DSM · ម៉ូដែល 3D",
        "text": "តម្រឹមរូបថតដែលបានថត ដើម្បីបង្កើត Point Cloud រូបភាព Ortho, DSM និងម៉ូដែល 3D។",
        "alt": "ម៉ូដែល 3D នៃការដ្ឋានការងារដីដែលបង្កើតពីរូបថត Drone ដែលបង្ហាញជម្រាលកាត់ និងដីរាបស្មើជា 3D"
      },
      {
        "title": "វេទិកា",
        "text": "ដាក់រូបភាព Ortho និងម៉ូដែល 3D ទៅលើវេទិកា DroneSquare ដើម្បីមើល និងវាស់វែងលើផែនទី។",
        "alt": "សញ្ញាកម្មវិធី DroneSquare"
      }
    ]
  },
  "education": {
    "eyebrow": "ការបណ្ដុះបណ្ដាល · ការប្រឹក្សា · ច្បាប់ · សុវត្ថិភាព",
    "title": "ចាប់ពីប្រតិបត្តិការ Drone ដល់ការប្រើកម្មវិធី<br/>យើងនៅជាមួយអ្នកតាមការដ្ឋាន",
    "cards": [
      {
        "kicker": "ការបណ្ដុះបណ្ដាល",
        "title": "ការបណ្ដុះបណ្ដាលតាមការដ្ឋាន",
        "text": "ការបណ្ដុះបណ្ដាលតាមការដ្ឋាន ចាប់ពីប្រតិបត្តិការ Drone ដល់ការប្រើកម្មវិធី ជួយបង្កើនសមត្ថភាពអនុវត្តការងារ។",
        "alt": "ដៃទាំងពីរកំពុងបញ្ជាឧបករណ៍បញ្ជា Drone ដែលភ្ជាប់ថេប្លេត"
      },
      {
        "kicker": "ការប្រឹក្សា",
        "title": "វិធីប្រើ Drone ល្អបំផុត",
        "text": "ផ្ដល់វិធីប្រើ Drone ល្អបំផុត និងយុទ្ធសាស្ត្រអនុវត្តតាមលក្ខណៈគម្រោង។",
        "alt": "មនុស្សពីរនាក់ពាក់អាវពន្លឺកំពុងចង្អុលប្លង់ជាមួយគ្នា"
      },
      {
        "kicker": "ច្បាប់",
        "title": "គោរពច្បាប់ហោះហើរ និងវាស់វែង",
        "text": "គោរពច្បាប់ហោះហើរ Drone និងវាស់វែង ដើម្បីផ្ដល់សេវាប្រកបដោយសុវត្ថិភាព និងស្របច្បាប់។",
        "alt": "ដៃកម្មករកំពុងសរសេរលើក្ដារតោងឯកសារ"
      },
      {
        "kicker": "ការបណ្ដុះបណ្ដាលសុវត្ថិភាព",
        "title": "គោលការណ៍ណែនាំសម្រាប់សុវត្ថិភាពកម្មករ",
        "text": "ផ្ដល់ការបណ្ដុះបណ្ដាល និងគោលការណ៍ណែនាំជាប្រព័ន្ធសម្រាប់សុវត្ថិភាពកម្មករពេលប្រើ Drone។",
        "alt": "មួកសុវត្ថិភាព ស្រោមដៃ ឧបករណ៍ការពារត្រចៀក និងវ៉ែនតាសុវត្ថិភាព"
      }
    ]
  },
  "partners": {
    "title": "ដៃគូរបស់យើង",
    "logos": [
      "Soosung Engineering",
      "Taeyoung E&C",
      "Hyundai E&C",
      "SK ecoengineering",
      "Woodae E&P",
      "K water Tech",
      "Punglim Industrial",
      "Hwalrim Construction",
      "Korea Fisheries Infrastructure Public Agency",
      "HJ Shipbuilding & Construction",
      "Liberaware"
    ]
  },
  "rows": {
    "pfLayers": {
      "kicker": "ស្រទាប់ផ្នែកកាត់",
      "title": "ជ្រើសថ្ងៃថត និងស្រទាប់ ដើម្បីត្រួតគ្នា",
      "text": "នៅក្នុងបញ្ជីស្រទាប់នៃក្រាហ្វផ្នែកកាត់ បើក និងបិទខ្សែដីតាមថ្ងៃថត ខ្សែគម្រោង DXF និង BIM ដើម្បីប្រៀបធៀបក្នុងក្រាហ្វតែមួយ។",
      "alt": "ក្រាហ្វផ្នែកកាត់ពិត និងបញ្ជីស្រទាប់ កំពុងជ្រើសបើកស្រទាប់ mesh នៃថ្ងៃថតបី។"
    },
    "earthwork": {
      "kicker": "បរិមាណការងារដីតាមខ្សែបន្ទាត់ និងតំបន់",
      "title": "គ្រាន់តែគូរតំបន់ ក៏គណនាការងារដីតាមថ្ងៃថតនីមួយៗ",
      "text": "បរិមាណដីកាយ និងដីចាក់ ត្រូវបានគណនាដោយស្វ័យប្រវត្តិតាមថ្ងៃថតនីមួយៗ។ មើលវឌ្ឍនភាពធៀបនឹងបរិមាណគម្រោង និងអ្វីដែលនៅសល់ក្នុងតារាងតែមួយ ហើយទាញយកជា CSV បាន។",
      "alt": "តារាងសរុបការងារដីនៅលើអេក្រង់ការងារដីពិត ដែលបែងចែកដីកាយ និងដីចាក់តាមប្រភេទដី ជាមួយបរិមាណគម្រោង បរិមាណនៅសល់ ចំនួនបូកសរុបប្រចាំថ្ងៃ និងវឌ្ឍនភាពតាមថ្ងៃថត។"
    },
    "measure": {
      "kicker": "ការវាស់ 2D/3D",
      "title": "ប្រវែង ផ្ទៃ និងមាឌ នៅលើអេក្រង់ភ្លាមៗ",
      "text": "ចុចចំណុចមួយ ដើម្បីទទួលកូអរដោនេ និងកម្ពស់ ភ្ជាប់ចំណុចច្រើន ដើម្បីទទួលប្រវែងតាមកំណាត់នីមួយៗ។ គូរតំបន់ ដើម្បីដឹងផ្ទៃ និងមាឌដែលគិតជម្រាលផង។",
      "alt": "ការវាស់ផ្ទៃនៅលើដីរាបស្មើក្នុងអេក្រង់ 3D ពិត (ពង្រីក)។ ផ្លាកកណ្ដាលបង្ហាញផ្ទៃ 3D 1330.57 m² និងផ្ទៃប្លង់ 1328.98 m² ព្រមទាំងប្រវែងជ្រុងនីមួយៗ។"
    },
    "issue": {
      "kicker": "បញ្ហា",
      "title": "ទុកបញ្ហានៅកន្លែងនោះ ហើយពិនិត្យតាមថ្ងៃថត",
      "text": "សម្គាល់បញ្ហាជាចំណុច ខ្សែ ឬតំបន់ ហើយកត់ត្រាខ្លឹមសារ និងស្ថានភាព។ ប្ដូរថ្ងៃថតដើម្បីមើលការផ្លាស់ប្ដូរនៅកន្លែងបញ្ហាដដែល។",
      "alt": "តំបន់បញ្ហាការហូរច្រោះដីជម្រាលដែលបានជ្រើសនៅក្នុងអេក្រង់ 2D ពិត និងផ្ទាំងព័ត៌មានបញ្ហាខាងឆ្វេង ដែលបង្ហាញថ្ងៃថត និន្នាការកម្រិតបញ្ហា និងព័ត៌មានបញ្ហា។"
    },
    "geolog": {
      "kicker": "រូបថត · វីដេអូ",
      "title": "រូបថត និងវីដេអូការដ្ឋានប្រមូលនៅកន្លែងដែលបានថត",
      "text": "ផ្ទុករូបថត និងវីដេអូពីការដ្ឋានឡើង នោះវានឹងប្រមូលជាសញ្ញាតាមទីតាំង។ ចុចសញ្ញាដើម្បីបើកមើលនៅកន្លែងនោះភ្លាមៗ។",
      "alt": "ផ្ទាំងរូបថត និងវីដេអូខាងឆ្វេងនៃអេក្រង់ 2D ពិត និងកាតកំណត់ត្រាវីដេអូដែលបើកពីសញ្ញាលើផែនទី។"
    },
    "pano": {
      "kicker": "360°",
      "title": "ចូលមើលខាងក្នុងការដ្ឋានដោយរូបថត 360°",
      "text": "ផ្ទុករូបថត 360° ឡើង ហើយមើលខាងក្នុងការដ្ឋានដូចឈរនៅកន្លែងដែលបានថត។",
      "alt": "អេក្រង់មើល 360° ពេញនៃកម្មវិធីពិត៖ ខាងក្នុងអគារកំពុងសាងសង់ ផែនទីតូចទីតាំង ប៊ូតុងប្ដូររូបថត (1/3) និងប្ដូរទៅ 2D។"
    },
    "equip": {
      "kicker": "ការក្លែងធ្វើផ្លូវឧបករណ៍",
      "title": "ផ្លូវឧបករណ៍ និងការត្រួតគ្នានៃកាំការងារ ជាមុន",
      "text": "ដាក់ឧបករណ៍ និងគូរផ្លូវនៅក្នុងការតាមដានការដ្ឋាន 3D។ ពេលចាក់ ឧបករណ៍ធ្វើចលនា ហើយសញ្ញាគ្រោះថ្នាក់លេចឡើងកន្លែងដែលកាំការងារត្រួតគ្នា។",
      "alt": "នៅក្នុងអេក្រង់ការតាមដានការដ្ឋាន 3D ពិត ម៉ាស៊ីនជីកពីរឆ្លងកាត់គ្នាតាមផ្លូវផ្ទុយគ្នា តំបន់គ្រោះថ្នាក់លេចឡើងពេលកាំការងារត្រួតគ្នា ហើយឡានដឹកដីឆ្លងកាត់ចន្លោះពួកវាទៅទិសខាងជើង។"
    }
  },
  "scenes": {
    "view": {
      "eyebrow": "2D · 3D · 4D",
      "title": "ពីប្លង់ទៅ 3D និងតាមពេលវេលា",
      "lead": "ពិនិត្យការដ្ឋានដែលថតដោយ Drone ជារូបភាព Ortho 2D និងម៉ូដែល 3D<brd/> ហើយបែងចែកអេក្រង់រហូតដល់ 4 ដើម្បីប្រៀបធៀបតាមថ្ងៃថត។",
      "stepsLabel": "ជំហានមើល",
      "steps": [
        {
          "k": "រូបភាព Ortho 2D",
          "d": "ផែនទីគុណភាពខ្ពស់ពីរូបថត Drone"
        },
        {
          "k": "ម៉ូដែល 3D",
          "d": "ប្ដូរការដ្ឋានដដែលទៅអេក្រង់ 3D"
        },
        {
          "k": "ស៊េរីពេលវេលា 4D",
          "d": "បែងចែកអេក្រង់ជា 4 ដើម្បីប្រៀបធៀបតាមថ្ងៃថត"
        }
      ],
      "viewLabel": "ការដ្ឋានការងារដីដែលបង្កើតពីទិន្នន័យ Drone ពិត។ ផែនទី Ortho ប្ដូរទៅអេក្រង់ 3D បន្ទាប់មកអេក្រង់បែងចែកជា 4 ដើម្បីប្រៀបធៀបវឌ្ឍនភាពសំណង់នៃថ្ងៃថតបួន ពីខែមីនា 2025 ដល់ខែមីនា 2026។"
    },
    "bridge": {
      "eyebrowLanding": "ការវាស់ · ការងារដី · ដីធ្លី",
      "eyebrowPlatform": "ការវាស់ · ផ្នែកកាត់ · ការងារដី",
      "title": "គូរខ្សែមួយ ដើម្បីមើលក្នុងដី និងរចនាសម្ព័ន្ធ",
      "lead": "គូរខ្សែលើអេក្រង់ 3D ដើម្បីទទួលផ្នែកកាត់ដែលកាត់ដី និង BIM ជាមួយគ្នា។<brd/> ត្រួតតាមស៊េរីពេលវេលា ហើយនាំចេញជា TXT·CSV·DXF ភ្លាមៗ។",
      "stepsLabel": "ជំហានផ្នែកកាត់",
      "steps": [
        {
          "k": "ផ្នែកកាត់បណ្ដោយ",
          "d": "គូរខ្សែតាមអ័ក្សស្ពាន ដើម្បីទទួលផ្នែកកាត់ភ្លាមៗ"
        },
        {
          "k": "ផ្នែកកាត់ទទឹង",
          "d": "ផ្នែកកាត់ដែលគូរឆ្លងកាត់ទីតាំងសសរ"
        },
        {
          "k": "ត្រួតតាមថ្ងៃថត",
          "d": "ខ្សែដីតាមថ្ងៃថត ព្រមទាំងស្រទាប់ DXF·BIM ក្នុងក្រាហ្វតែមួយ"
        },
        {
          "k": "នាំចេញ",
          "d": "កំណត់ចន្លោះចំណុច ហើយនាំចេញជា TXT·CSV·DXF"
        }
      ],
      "viewLabel": "ម៉ូដែល 3D នៃការដ្ឋានសាងសង់ស្ពានពិត ត្រួតជាមួយ BIM ស្ពាន (ធ្នឹម បន្ទះ សសរ ជើងស្ពាន)។ គូរខ្សែតាមអ័ក្សស្ពាន ខ្សែដី និងផ្នែកកាត់ស្ពានត្រូវបានគូរនៅក្នុងក្រាហ្វខាងក្រោម បន្ទាប់មកផ្នែកកាត់ទទឹងនៅសសរ ការប្រៀបធៀបខ្សែដីនៃថ្ងៃថតពីរ និងការនាំចេញទិន្នន័យតាមចន្លោះចំណុច (TXT·CSV·DXF)។",
      "lon": "បណ្ដោយ",
      "crs": "ទទឹង",
      "capture": "ចាប់យករូបភាព",
      "extract": "ទាញចំណុច",
      "popTitle": "នាំចេញទិន្នន័យ",
      "popSpacing": "ចន្លោះចំណុច",
      "popUnit": "m",
      "dateNow": "2026.03.20",
      "datePast": "2025.11.21",
      "bim": "BIM ស្ពាន",
      "distance": "ចម្ងាយ (m)",
      "height": "កម្ពស់ (m)"
    },
    "layers": {
      "eyebrow": "ការត្រួតស្រទាប់",
      "title": "ទិន្នន័យទាំងអស់ក្នុងពេលតែមួយ",
      "lead": "ត្រួតប្លង់រចនា ទិន្នន័យសុរិយោដី និងកំណត់ត្រាការដ្ឋាន នៅក្នុងអេក្រង់ 3D តែមួយ<brd/> ហើយពិនិត្យហានិភ័យមនុស្ស និងឧបករណ៍ជាមុននៅក្នុងការតាមដានការដ្ឋាន 3D។",
      "stepsLabel": "ជំហានស្រទាប់",
      "steps": [
        {
          "k": "DXF · GIS សុរិយោដី",
          "d": "ផ្លូវគម្រោង និងព្រំដីលើការដ្ឋាន 3D"
        },
        {
          "k": "BIM",
          "d": "BIM រចនាសម្ព័ន្ធជាមួយសណ្ឋានដី"
        },
        {
          "k": "Point Cloud",
          "d": "ការដ្ឋានជាទិន្នន័យចំណុច"
        },
        {
          "k": "វ៉ិចទ័រ",
          "d": "បំពង់ក្រោមដីជាខ្សែមាឌ"
        },
        {
          "k": "ការកាត់",
          "d": "កាត់ដោយប្រអប់ ដើម្បីមើលផ្នែកកាត់ក្រោមដី"
        },
        {
          "k": "កំណត់ត្រាការដ្ឋាន",
          "d": "បញ្ហា រូបថត វីដេអូ និង 360° តាមទីតាំង"
        },
        {
          "k": "ការក្លែងធ្វើមនុស្ស · ឧបករណ៍",
          "d": "កាំការងារ និងហានិភ័យផ្លូវជាមុន"
        }
      ],
      "viewLabel": "អេក្រង់ 3D នៃការដ្ឋានការងារដីពីទិន្នន័យ Drone ពិត។ ផ្លូវរចនា ព្រំសុរិយោដី BIM ជញ្ជាំងទប់ Point Cloud បំពង់ក្រោមដី (ខ្សែមាឌ) ផ្នែកកាត់ប្រអប់ និងទីតាំងបញ្ហា និងរូបថតការដ្ឋាន ត្រូវបានត្រួតតាមលំដាប់ បន្ទាប់មកនៅក្នុងការតាមដានការដ្ឋាន 3D ម៉ាស៊ីនជីក និងឡានដឹកដីធ្វើចលនាតាមផ្លូវដែលបានគូរ ហើយតំបន់គ្រោះថ្នាក់លេចឡើងពេលកាំការងាររបស់ម៉ាស៊ីនជីកពីរត្រួតគ្នា។",
      "wallBim": "BIM ជញ្ជាំងទប់",
      "waterPipe": "បំពង់ទឹកស្អាត",
      "stormPipe": "បំពង់ទឹកភ្លៀង",
      "issues": [
        "ការហូរច្រោះដីជម្រាល",
        "ប្រឡាយស្ទះ",
        "ស្នាមប្រេះដីចាក់"
      ]
    },
    "dates": {
      "main": "20/03/2026",
      "panes": [
        "14/03/2025",
        "18/07/2025",
        "21/11/2025",
        "20/03/2026"
      ]
    }
  }
} as const;

export default landingSite;
